shadow$provide[440] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec4 remapSTPQScale;

vec4 screenMapSTPQ(vec4 xyzw, out vec4 stpq) {
  stpq = xyzw * remapSTPQScale;
  return xyzw;
}
`;

};